import React from 'react';

export enum CallPhase {
  PreCall = 'pre-call',
  DuringCall = 'during-call',
  PostCall = 'post-call',
}

export interface TagAction {
  id: string;
  title: string;
  description?: string;
  renderAction: () => React.ReactNode;
}

export interface TagActionRule {
  id: string;
  phase: CallPhase;
  tagNames: string[];
  requireAllTags?: boolean;
  actions: TagAction[];
}
